import { useSuspenseGetApplicationIfLoggedIn } from '../../api/lending/lapiHooks.suspense';
import { daysSinceStatusDate } from '../Account/Dashboard.helpers';

const EXPIRE_DECLINE_AFTER_DAYS = 30 as const;

export function useSuspenseIsLockedOutDueToDecline():
  | { isLockedOut: false; daysUntilLockOutExpires: null }
  | { isLockedOut: true; daysUntilLockOutExpires: number } {
  const { application } = useSuspenseGetApplicationIfLoggedIn();

  const declineStatus = application?.decline_status;

  if (!declineStatus) {
    return {
      isLockedOut: false,
      daysUntilLockOutExpires: null,
    };
  }

  const daysSinceDecline = daysSinceStatusDate(application);

  if (daysSinceDecline === null) {
    return {
      isLockedOut: false,
      daysUntilLockOutExpires: null,
    };
  }

  const isLockedOut = daysSinceDecline < EXPIRE_DECLINE_AFTER_DAYS;

  if (!isLockedOut) {
    return {
      isLockedOut: false,
      daysUntilLockOutExpires: null,
    };
  }

  return {
    isLockedOut: true,
    daysUntilLockOutExpires: EXPIRE_DECLINE_AFTER_DAYS - daysSinceDecline,
  };
}
